var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.162,
    height: 10.808,
    viewBox: "0 0 12.162 10.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6803",
    "data-name": "Group 6803",
    transform: "translate(0.5 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M180.5,99.866h6.349L184.588,96.7a.093.093,0,0,1,0-.116l2.24-2.685h-5.1v4.072H180.5Z",
    transform: "translate(-176.239 -91.677)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2821",
    "data-name": "Rectangle 2821",
    width: 5.492,
    height: 5.966,
    transform: "translate(0 0.329)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    "data-name": "Line 424",
    x2: 3,
    transform: "translate(1.205 2.668)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    y1: 10.637,
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/countryIcon.a22160eae95c45e180e5914a22a93a76.svg";
export { ForwardRef as ReactComponent };